export default "__VITE_ASSET__DasQazvm__"